import React from 'react'

import { useNavigate } from 'react-router-dom'
import { Machine } from '@/services/model/machine'
import { Roles } from '@/services/repository/users'
import { anonCanAddFailure } from '@/env/config'
import { Spinner } from '@/components/spinner'
import { useAppContext } from '@/context/app'

export interface DafaultMenuProps {
    machine: Machine
}

export const CoordinatorMenu = ({ machine }: DafaultMenuProps) => {
    const { services, session, translates } = useAppContext()
    const navigate = useNavigate()

    if (!machine || !translates) {
        return <Spinner />
    }

    return <div className="machine-menu-wrapper">
        {machine?.imei ? <>
            <a className='main-orange-btn' onClick={() => { navigate(`/communal/machine/${machine.id}/checklist/wizard`) }}>
                {translates.for('menus.communal.machine.checklist')}
            </a>
        </> : null}
    </div>
}
